import type * as React from 'react'

// NOTE (Phase 00 contract gap, still open): reference/ICON-NORMALISATION.md §(c) specifies a
// shared `SvgIconProps` from './types.ts'. That file has no owning task in any phase file yet
// (flagged in PHASE-00's Notes as an open gap). This component must not create `./types.ts`
// unprompted, so the prop type is inlined here rather than imported. Once `./types.ts` exists,
// this local type should be replaced with an import from it to match every other icon component.
type SvgIconProps = Omit<React.SVGProps<SVGSVGElement>, 'children'> & {
  /** Accessible name. Omit for a purely decorative icon (default: aria-hidden). */
  title?: string
}

export function IconFolders16({ title, ...rest }: SvgIconProps) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.58301 2C7.85344 2 8.11665 2.08776 8.33301 2.25L10 3.5H14.25C14.5401 3.5 14.8196 3.60098 15.042 3.7832L15.1338 3.86621L15.2168 3.95801C15.399 4.18043 15.5 4.45995 15.5 4.75V10.3057C15.5 10.6224 15.3744 10.9264 15.1504 11.1504C14.9264 11.3744 14.6224 11.5 14.3057 11.5H13V12.8057C13 13.1224 12.8744 13.4264 12.6504 13.6504C12.4264 13.8744 12.1224 14 11.8057 14H2.25C1.91848 14 1.60063 13.8682 1.36621 13.6338C1.13179 13.3994 1 13.0815 1 12.75V5.75C1 5.41848 1.13179 5.10063 1.36621 4.86621C1.60063 4.63179 1.91848 4.5 2.25 4.5H3.5V3.25C3.5 2.91848 3.63179 2.60063 3.86621 2.36621C4.10063 2.13179 4.41848 2 4.75 2H7.58301ZM2.5 12.5H11.5V7.5H7.25C7.08774 7.5 6.92962 7.44696 6.7998 7.34961L5 6H2.5V12.5ZM5 4.5H5.08301C5.35344 4.5 5.61665 4.58776 5.83301 4.75L7.5 6H11.75C12.0401 6 12.3196 6.10098 12.542 6.2832L12.6338 6.36621L12.7168 6.45801C12.899 6.68043 13 6.95995 13 7.25V10H14V5H9.75C9.58774 5 9.42962 4.94696 9.2998 4.84961L7.5 3.5H5V4.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
